import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, NgModule } from '@angular/core';
import { OrdersService } from '../../../services/orders.service';
import { GeneralEmitterService } from '../../../services/general-emitter.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { saveAs } from 'file-saver';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';


@Component({
  selector: 'app-order-detail-update',
  standalone: true,
  imports: [ToastModule, CommonModule,ReactiveFormsModule,
    FormsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [MessageService],
  templateUrl: './order-detail-update.component.html',
  styleUrl: './order-detail-update.component.scss'
})
export class OrderDetailUpdateComponent {
  @Input() showOrders: number = 1;
  public labels = ['Revisión de solicitud', 'Realizar Pago', 'En proceso de envío', 'Entregado']
  public index = 1;
  usr: string = '';
  showPayment: boolean = false;
  showPayment22: boolean = false;
  products: any = [];
  listItems: any = [];
  paymentId = '';
  orderList: any = [];
  backUpList: any = [];
  paymentList: any= [];
  orderInfo: string = '';
  totalAmount: number = 0;
  showUpdate: boolean = false;
  isValidQuotation: boolean = false;
  priceShipping = '0.00';
  setTrackingGuide: boolean = false;

  constructor(
    private fb: FormBuilder,
    private orderService: OrdersService,
    private emitterData: GeneralEmitterService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    
    this.usr = localStorage.getItem('usr') || '';
    this.getOrdersToValidate(this.showOrders);
  }

  ngOnChanges() {
    this.orderList = [];
    this.backUpList = [];
    if (this.showOrders === 5) {
      this.getAllOrders();
    } else {
      this.getOrdersToValidate(this.showOrders);
    }
  }

  getAllOrders() {
    this.orderService.getAllOrders().subscribe({
      next: (res: any) => {
        this.orderList = res?.listOrders ?? [];
        this.backUpList = [...this.orderList];
      },
      error: (err: any) => {
        if ( err?.status == 401 ) {
          this.messageService.add({ severity:'error', summary: 'Ocurrió un error', detail: "Su sesión ha expirado, por favor inicie sesión nuevamente." });
        } else {
          this.messageService.add({ severity:'warning', summary: 'Ocurrió un error', detail: err?.message ?? '' });
        }
      }
    });
  }

  getOrdersToValidate(id: number) {
    this.usr = localStorage.getItem('usr') || '';
    this.orderService.getOrdersToValidate(id).subscribe({
      next: (res: any) => {
        this.orderList = res?.listOrders ?? [];
        if ( this.orderList.length > 0 ) {
          this.orderList.forEach((order: any) => {
            order.details.forEach((detail: any) => {
              detail.priceUpdated = (Number(detail.unit_price).toFixed(2));
            });
          });
        }
        console.log('this.orderList :', this.orderList);
        this.backUpList = [...this.orderList];
        // this.setupFormArrays();
      },
      error: (err: any) => {
        if ( err?.status == 401 ) {
          this.messageService.add({ severity:'error', summary: 'Ocurrió un error', detail: "Su sesión ha expirado, por favor inicie sesión nuevamente." });
        } else {
          this.messageService.add({ severity:'warning', summary: 'Ocurrió un error', detail: err?.message ?? '' });
        }
      }
    });
  }

  async updateOrder(order: any) {
    console.log('order :', order);
    let orderInfo: any = [];
    order.details.forEach((detail: any) => {
      orderInfo.push(
        {
          order: detail.order,
          sku: detail.sku,
          price: detail.priceUpdated
        });
    })

    let payload = {
      order: orderInfo,
      shippingCost: this.priceShipping
    }
    this.orderService.updatePrice(payload).subscribe({
      next: (res: any) => {
        this.messageService.add({ severity:'success', summary: 'Éxito', detail: 'Precios actualizados correctamente.' });
      }
    });
    this.showUpdate = false
    await this.getOrdersToValidate(this.showOrders);

  }

  showUpdatePayment(val: boolean) {
    this.isValidQuotation = val ? false : val;
    this.showUpdate = val;
  }

  showQuotation(orderId: string) {
    this.orderService.generatePdfQuotation({ order: orderId, userId: this.usr }).subscribe({
      next: (res: Blob) => {
        console.log('received blob size:', res?.size);
        // Use file-saver to trigger download
        try {
         const pdfBlob = new Blob([res], { type: 'application/pdf' });
         console.log('pdfBlob :', pdfBlob);
         saveAs(pdfBlob, `Cotización_Orden_${orderId}.pdf`);
         this.isValidQuotation = true;
        } catch (err) {
          const url = URL.createObjectURL(res);
          window.open(url, '_blank');
          setTimeout(() => URL.revokeObjectURL(url), 5000);
        }
      },
      error: (err: any) => {
        console.error('Error downloading PDF', err);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message ?? 'No se pudo descargar el PDF' });
      }
    });
  }

  getInfo(value: any, order: any, position: any) {
    this.orderList[order].details[position].unit_price = value;
  }

  sendEmailQuotation(orderId: string) {
    let payload = {
      order: orderId,
      userId: this.usr
    }
    this.orderService.sendQuotationEmail(payload).subscribe({
      next: (res: any) => {
        this.messageService.add({ severity:'success', summary: 'Éxito', detail: 'Correo enviado correctamente.' });
        this.getOrdersToValidate(this.showOrders);
      },
      error: (err: any) => {
        this.messageService.add({ severity:'error', summary: 'Ocurrió un error', detail: err?.message ?? '' });
      }
    });
  }

  searchProducts( evt: any) {
    if ( evt?.target?.value ) {
      this.orderList = this.backUpList.filter((item:any) => item?.order_id?.toString()?.includes(evt?.target?.value) );
    } else {
      this.orderList = [...this.backUpList];
    }
  }

  setShippingCost(event: any, order: any) {
    this.priceShipping = Number(event?.target?.value)?.toFixed(2) || '0.00';
    order.shippingCost = Number(event?.target?.value)?.toFixed(2) || '0.00';
  }

  async setTracking(orderId: any, trackingGuide: any) {
    let payload = {
      orderId,
      trackingGuide: trackingGuide.trackingGuide || '',
      trackingCompany: trackingGuide.trackingCompany || '',
      trackingUrl: trackingGuide.trackingUrl || ''
    }
    this.orderService.updateOrderTracking(payload).subscribe({
      next: (res: any) => {
        this.messageService.add({ severity:'success', summary: 'Éxito', detail: 'Seguimiento actualizado correctamente.' });
      }
    });
    this.showUpdate = false
    await this.getOrdersToValidate(this.showOrders);
  }

  setDelivered(orderId: any, usr: any) {
    let payload = {
      orderId,
      usr: usr,
      status: 'Entregado'
    }
    this.orderService.updateOrderStatus(payload).subscribe({
      next: async (res: any) => {
        this.messageService.add({ severity:'success', summary: 'Éxito', detail: 'Estado de la orden actualizado correctamente.' });
            await this.getOrdersToValidate(this.showOrders);

      }
    });
  }
}
